/**
 * AutoCount - Manufacturers List Page
 */

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

const manufacturers = [
  { name: "Toyota", country: "Japan", website: "toyota.com", vehicles: 156, parts: 2340 },
  { name: "Honda", country: "Japan", website: "honda.com", vehicles: 134, parts: 1980 },
  { name: "Ford", country: "USA", website: "ford.com", vehicles: 145, parts: 2150 },
  { name: "Chevrolet", country: "USA", website: "chevrolet.com", vehicles: 128, parts: 1890 },
  { name: "BMW", country: "Germany", website: "bmw.com", vehicles: 112, parts: 1670 },
  { name: "Mercedes-Benz", country: "Germany", website: "mercedes-benz.com", vehicles: 118, parts: 1750 },
  { name: "Volkswagen", country: "Germany", website: "vw.com", vehicles: 98, parts: 1450 },
  { name: "Hyundai", country: "South Korea", website: "hyundai.com", vehicles: 89, parts: 1320 },
];

function ManufacturersList(): JSX.Element {
  const columns = [
    { Header: "Name", accessor: "name", width: "25%" },
    { Header: "Country", accessor: "country", width: "20%" },
    { Header: "Website", accessor: "website", width: "20%" },
    { Header: "Vehicles", accessor: "vehicles", width: "15%" },
    { Header: "Parts", accessor: "parts", width: "15%" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Auto Manufacturers
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows: manufacturers }}
                  isSorted={true}
                  entriesPerPage={{ defaultValue: 10, entries: [5, 10, 25, 50] }}
                  showTotalEntries={true}
                  canSearch={true}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ManufacturersList;
